import { render, staticRenderFns } from "./CreateKnowledgeCatgeoryView.vue?vue&type=template&id=20638960&"
import script from "./CreateKnowledgeCatgeoryView.vue?vue&type=script&lang=js&"
export * from "./CreateKnowledgeCatgeoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports